module.exports = __webpack_public_path__ + "img/cls.9d0dc43d.svg";